<template>
  <div class="borrowing-wrapper">
    <div class="content-wrapper">
      <img
        src="https://files.jinr.com/jinr-index/img/borrow-bg.png"
        alt=""
        srcset=""
        class="bg-img"
      />
      <div class="text-wrapper">
        <h2>诚信运营, 客户至上</h2>
        <h4>始终坚持为用户提供更优质的金融服务</h4>
      </div>
    </div>
    <div class="lend-box">
      <h4>操作简单 极速审核</h4>
      <div class="mid-wrapper">
        <div class="left item">
          <div class="icon">
            <img src="https://files.jinr.com/jinr-index/img/borrow-icon-01.png" alt="" srcset="" />
          </div>
          <div class="text">
            <h5>门槛低</h5>
            <p>0抵押0担保</p>
          </div>
        </div>
        <div class="right item">
          <div class="icon">
            <img src="https://files.jinr.com/jinr-index/img/borrow-icon-02.png" alt="" srcset="" />
          </div>
          <div class="text">
            <h5>放款快</h5>
            <p>最快3分钟到账</p>
          </div>
        </div>
      </div>
      <a
        class="btn"
        href="https://jinrfe.jinr.com/jyd-borrowing-pc/index.html#/account/login"
        target="_blank"
      >
        立即借款
      </a>
    </div>
    <p class="tips-borrow">市场有风险，出借需谨慎</p>
  </div>
</template>
<script>
export default {
  name: 'borrowing'
};
</script>
<style lang="less" scoped>
.borrowing-wrapper {
  position: relative;
  overflow: hidden;
  background: #ffffff;
  height: 100%;
  .content-wrapper {
    display: flex;
    position: relative;
    height: 3.26rem;
    justify-content: center;
    align-items: center;
  }
  .bg-img {
    position: absolute;
    display: block;
    height: 100%;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
  }
  .text-wrapper {
    position: relative;
    z-index: 20;
    color: #ffffff;
    text-align: center;
    h2 {
      font-weight: 600;
      font-size: 0.42rem;
      line-height: 0.7rem;
    }
    h4 {
      font-size: 0.26rem;
      line-height: 0.36rem;
    }
  }
  .lend-box {
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    z-index: 20;
    margin-top: 10%;
    h4 {
      font-family: 'PingFangSC-Regular';
      font-size: 0.33rem;
      color: #333333;
      line-height: 0.34rem;
      margin: 0 auto 0.53rem;
    }
    .mid-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-around;
      padding: 0 1.35rem;
      .item {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
        .icon {
          width: 0.53rem;
          height: 0.61rem;
          text-align: center;
          img {
            height: 100%;
          }
        }
        .text {
          h5 {
            color: #333333;
            font-size: 0.26rem;
            line-height: 2.4;
          }
          p {
            color: #666666;
            font-size: 0.22rem;
            line-height: 1;
          }
        }
      }
    }
    .btn {
      width: 3.16rem;
      height: 0.71rem;
      background-color: #287bf2;
      border-radius: 0.4rem;
      text-align: center;
      font-family: 'PingFangSC-Medium';
      font-size: 0.3rem;
      color: #ffffff;
      line-height: 0.7rem;
      background: #287bf2;
      margin-top: 0.5rem;
    }
  }
  .tips-borrow {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0.6rem;
    font-size: 0.2rem;
    color: #c8c8c8;
    letter-spacing: 0.06rem;
    text-align: center;
  }
}
</style>
